"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lightPalette = void 0;
const sharedPalette_1 = require("./sharedPalette");
const YamaColors_1 = __importDefault(require("./YamaColors"));
// TODO: As part of light theme, map the rest of the colors in this file
// to its respective Yama color using the documents referenced in this pull request:
// https://github.com/jasklabs/fleet/pull/1661
const common = {
    white: YamaColors_1.default['white-10'],
    black: '#000000',
};
const grey = {
    400: YamaColors_1.default['white-100'],
    500: YamaColors_1.default['grey-70'],
    700: YamaColors_1.default['grey-30'],
};
const primary = {
    contrastText: YamaColors_1.default['white-10'],
    light: YamaColors_1.default['primary-40'],
    main: YamaColors_1.default['primary-60'],
    dark: YamaColors_1.default['primary-80'],
};
const secondary = {
    contrastText: YamaColors_1.default['black-90'],
    light: YamaColors_1.default['white-60'],
    main: YamaColors_1.default['white-80'],
    dark: YamaColors_1.default['white-100'],
};
const error = {
    contrastText: YamaColors_1.default['white-10'],
    light: YamaColors_1.default['critical-40'],
    main: YamaColors_1.default['critical-60'],
    dark: YamaColors_1.default['critical-80'],
};
const warning = {
    contrastText: YamaColors_1.default['white-10'],
    light: YamaColors_1.default['warning-40'],
    main: YamaColors_1.default['warning-50'],
    dark: YamaColors_1.default['warning-60'],
};
const info = {
    contrastText: YamaColors_1.default['white-10'],
    light: YamaColors_1.default['grey-60'],
    main: YamaColors_1.default['primary-60'],
    dark: YamaColors_1.default['grey-30'],
};
const success = {
    contrastText: YamaColors_1.default['white-10'],
    light: YamaColors_1.default['success-40'],
    main: YamaColors_1.default['success-60'],
    dark: YamaColors_1.default['success-80'],
};
const background = {
    chip: YamaColors_1.default['white-50'],
    contrastText: YamaColors_1.default['black-90'],
    paperHover: YamaColors_1.default['white-30'],
    paper: YamaColors_1.default['white-10'],
    default: YamaColors_1.default['Platinum'],
};
const text = {
    primary: YamaColors_1.default['black-90'],
    secondary: YamaColors_1.default['grey-70'],
    error: YamaColors_1.default['critical-60'],
};
const link = {
    main: YamaColors_1.default['primary-60'],
    hover: YamaColors_1.default['primary-50'],
    visited: YamaColors_1.default['primary-80'],
    disabled: YamaColors_1.default['white-100'],
};
const border = YamaColors_1.default['white-80'];
const divider = YamaColors_1.default['white-80'];
const icon = YamaColors_1.default['grey-50'];
exports.lightPalette = {
    background,
    border,
    chart: sharedPalette_1.chart,
    common,
    divider,
    error,
    grey,
    icon,
    info,
    link,
    primary,
    secondary,
    status: sharedPalette_1.status,
    success,
    text,
    warning,
    reputation: sharedPalette_1.reputation,
    toast: sharedPalette_1.toast,
};
